import { Injectable } from '@angular/core';
import { configuration } from 'src/app/app.config';
import { NewRelicService } from 'src/lib/fl-newrelic/new-relic-initializer.service';
import { ConfigurationService } from 'src/app/core/configuration.service';
import {
  Logger,
  SeverityLevel,
  transformError,
} from 'src/app/shared/shared-base/amg-ui/logging/logging/logger';

@Injectable()
export class NewRelicLogger implements Logger {
  private _enabled: boolean = configuration.logging.newRelic.enabled;

  constructor(private _newRelicService: NewRelicService, private _config: ConfigurationService) {}

  public error(error: unknown, properties?: { [name: string]: string }): void {
    if (this._enabled) {
      const errInfo = transformError(error);
      this._newRelicService.newRelic?.noticeError(errInfo.error, {
        ...errInfo.properties,
        ...properties,
        ts: Date.now(),
        severityLevel: SeverityLevel.Error,
        level: 'Error',
        appSpace: 'FirstCall.FlightLog',
        environment: this._config.environmentDisplay,
      });
    }
  }

  public warning(message: string, properties?: { [name: string]: string }): void {
    if (this._enabled) {
      this._newRelicService.newRelic?.noticeError(message, {
        ...properties,
        ts: Date.now(),
        severityLevel: SeverityLevel.Warning,
        level: 'Warning',
        appSpace: 'FirstCall.FlightLog',
        environment: this._config.environmentDisplay,
      });
    }
  }

  public info(message: string, properties?: { [name: string]: string }): void {
    if (this._enabled) {
      this._newRelicService.newRelic?.noticeError(message, {
        ...properties,
        ts: Date.now(),
        severityLevel: SeverityLevel.Information,
        level: 'Information',
        appSpace: 'FirstCall.FlightLog',
        environment: this._config.environmentDisplay,
      });
    }
  }
}
